/* ****** axios配置文件 ****** */
import axios from "axios"; // 引入axios
import QS from "qs"; // 入qs模块，用来序列化post类型的数据
import { Message } from "element-ui"

//设置请求超时
axios.defaults.timeout = 60000;
// 请求地址
axios.defaults.baseURL = 'https://api.vogemotor.com'

export default axios



//////////////////
// WEBPACK FOOTER
// ./request/http.js
// module id = null
// module chunks = 